<template>
  <v-data-table
    :headers="headers"
    :items="filteredServices"
    class="px-5 services-table"
    :loading="loading"
    loading-text="Загрузка... Пожалуйста подождите"
    :mobile-breakpoint="300"
    :page="1"
    :items-per-page="10"
    :height="tableHeight"
    fixed-header
    hide-default-footer
  >
    <template v-slot:header>
      <tr>
        <td class="border-bottom pa-3"/>
        <td class="border-bottom pa-3"/>
        <td class="border-bottom pa-3" >
          <div>
            <v-text-field
              label="Название услуги" append-icon="mdi-magnify" class="font-sm"
              @input="debouncedSetFilterName" dense hide-details outlined
            />
          </div>
        </td>
        <td class="border-bottom pa-3"/>
        <td class="border-bottom pa-3" >
        </td>
        <td class="border-bottom pa-3" >
        </td>
        <td class="border-bottom pa-3" >
        </td>
        <td class="border-bottom pa-3"/>
        <td class="border-bottom pa-3"/>
      </tr>
    </template>
    <template v-slot:item.order="{ item }">
      <div>
        <v-text-field
          class="font-sm"
          dense
          hide-details
          outlined
          :value="item.order"
          @change="(val)=>debouncedSetOrderService(item,val)"
        />
      </div>
    </template>
    <template v-slot:item.check="{ item }">
      <div>
        <v-checkbox />
      </div>
    </template>
    <template v-slot:item.created_at="{ item }">
      <div class="d-flex justify-space-between align-center">
        {{ $moment(item.created_at).format('DD.MM.YYYY') }}
      </div>
    </template>
    <template v-slot:item.status="{ item }">
      <div class="badge font-xs w-100" :class="serviceStatusBadgeClass(item)">
        {{ item.status_display }}
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        class="background_transparent"
        large
        color="white"
        outlined
        @click="actionButton(item)"
      >
        {{serviceStatusActionButton(item)}}
      </v-btn>
    </template>
    <template v-slot:item.comment="{ item }">
      <v-text-field
        label="Комментарий"
        class="font-sm"
        dense
        hide-details
        outlined
      />
    </template>
    <template v-slot:item.toolbar="{ item }">
      <v-btn
        v-if="item.status === SERVICE_STATUSES.PUBLISHED"
        small
        class="background_transparent no-border"
        @click="$router.push(`/list-services/${item.id}`)"
      >
        <img src="@/assets/images/profile/arrowGo.svg" />

      </v-btn>
      <v-btn
        small
        class="background_transparent no-border"
        @click="goToEdit(item)"
      >
        <v-icon >mdi-pencil-outline</v-icon>

      </v-btn>
      <v-btn
      small
      class="background_transparent no-border"
      @click="$emit('deleteService',item)"
      >
        <v-icon class="cursor-pointer">mdi-delete</v-icon>
      </v-btn>
    </template>

    <template v-slot:no-data>
      Услуг не найдено.
    </template>

    <template v-slot:footer="{ props }">
      <v-data-footer
        :pagination="props.pagination"
        :options="props.options"
        items-per-page-text="Услуг на странице:"
        :items-per-page-options="[10, 20, 50, 100, 500, 1000]"
        :page-text="`Всего услуг: ${props.pagination.itemsLength}. Страница ${props.options.page} из ${props.pagination.pageCount}`"
        show-current-page
        show-first-last-page
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
import { debounce } from 'lodash';
import { SERVICE_STATUSES, SERVICE_STATUSES_TITLES } from '@/common/constants/serviceStatuses';

export default {
  name: 'ServicesTable',
  components: {
  },
  emits: ['publishedService', 'draftedService', 'changeOrderService'],
  data: () => ({
    tableHeight: 400,
    dialog: false,
    dialogDelete: false,
    filterName: '',
    headers: [
      {
        text: '',
        value: 'order',
        sortable: false,
        width: '90px',
        text2: '',
      },
      {
        text: '',
        value: 'check',
        sortable: false,
        width: '60px',
        text2: 'Выбрать кандидата',
      },
      {
        text: 'Название услуги',
        align: 'start',
        value: 'name',
        width: '280px',
        sortable: true,
      },
      {
        text: 'Дата добавления',
        value: 'created_at',
        width: '204px',
        sortable: true,
      },
      {
        text: 'Статус',
        value: 'status',
        width: '204px',
        sortable: false,

      },
      {
        text: 'Действия',
        align: 'center',
        value: 'actions',
        width: '204px',
      },
      {
        text: '',
        align: 'start',
        value: 'comment',
        width: '250px',
      },
      {
        text: '',
        align: 'start',
        value: 'toolbar',
        width: '250px',
      },
    ],
    paginationData: null,
  }),
  computed: {
    SERVICE_STATUSES() {
      return SERVICE_STATUSES;
    },
    ...mapGetters({
      loading: 'services/services/GET_LOADING_SERVICES',
      services: 'services/services/GET_ALL_SERVICES',
    }),
    filteredServices() {
      if (!this.filterName) return this.services;
      const needle = this.filterName.trim().toLowerCase();
      return this.services.filter(service => (service.name || '').toLowerCase().includes(needle));
    },
  },
  watch: {
  },
  methods: {
    // eslint-disable-next-line func-names
    debouncedSetFilterName: debounce(function (val) {
      this.filterName = val;
    }, 500),
    debouncedSetOrderService: debounce(function (item, value) {
      this.changeOrderService(item, value);
    }, 500),

    testingStatus(item) {
      return SERVICE_STATUSES_TITLES[item.status];
    },
    serviceStatusBadgeClass(item) {
      switch (item.status) {
        case SERVICE_STATUSES.DRAFT:
          return 'badge-draft';
        case SERVICE_STATUSES.PUBLISHED:
          return 'badge-published';
        default:
          return 'd-none';
      }
    },
    serviceStatusActionButton(service) {
      switch (service.status) {
        case SERVICE_STATUSES.DRAFT:
          return 'Опубликовать';
        case SERVICE_STATUSES.PUBLISHED:
          return 'Скрыть';
        default:
          return 'd-none';
      }
    },
    goToEdit(service) {
      this.$router.push({ name: 'update-service', params: { id: service.id } });
    },
    onPublishedService(service) {
      this.$emit('publishedService', service);
    },
    onDraftedService(service) {
      this.$emit('draftedService', service);
    },
    actionButton(service) {
      switch (service.status) {
        case SERVICE_STATUSES.DRAFT:
          this.onPublishedService(service);
          break;
        case SERVICE_STATUSES.PUBLISHED:
          this.onDraftedService(service);
          break;
        default: {
          return false;
        }
      }
    },
    changeOrderService(item, value) {
      this.$emit('changeOrderService', item, value);
    }
  },
  created() {
  },
  mounted() {
    const height = document.documentElement.clientHeight - 270;
    this.tableHeight = Math.max(height, this.tableHeight);
  },
};
</script>

<style lang="scss" scoped>
.services-table{
  & thead{
    background: red;
  }
  & .v-btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    font-size: 16px;
    padding: 10px 16px;
    ::v-deep span{
      line-height: 24px;
    }
    &.background_transparent{
      background: transparent;
      color: var(--color-blue-500)!important;
      &.no-border{
        border: none;
        box-shadow: none;
        color: var(--color-grey-500)!important;
        &:hover{
          box-shadow: none!important;
        }
      }
    }
  }
}

</style>
